import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import api from "../Services/api";

export interface IOperacao {
  ID: number;
  CARTORIO_ID: number;
  DESCRICAO: string;
}

interface IOperacaoContextData {
  getOperacoes(cartorio_id: number): Promise<void>;
  operacoes: IOperacao[];
  handleAddOperacao(n_operacao: IOperacao): void;
  handleUpdateOperacao(param: IOperacao): void;
  handleDeleteOperacao(param: IOperacao): void;
}

interface IOperacaoProviderProps {
  children: ReactNode;
}

const OperacaoContext = createContext({} as IOperacaoContextData);

function OperacaoProvider({ children }: IOperacaoProviderProps) {
  const [operacoes, setOperacao] = useState([] as IOperacao[]);

  async function getOperacoes(cartorio_id: number) {
    try {
      const { data } = await api.get(`/tipos-operacoes/${cartorio_id}`);

      console.log(data);
      setOperacao(data);
    } catch (error) {
      throw error;
    }
  }

  function handleAddOperacao(n_operacao: IOperacao) {
    setOperacao((prev) => [...prev, n_operacao]);
  }

  function handleDeleteOperacao(param: IOperacao) {
    const posicao = operacoes.indexOf(param);

    const novasOperacoes = operacoes.splice(posicao, 1);
    if (operacoes && operacoes.length > 0) {
      setOperacao(operacoes);
    } else {
      setOperacao({} as IOperacao[]);
    }
  }

  function handleUpdateOperacao(param: IOperacao) {
    const posicao = operacoes.indexOf(param);
    const update = operacoes.splice(posicao, 1, param);

    setOperacao(operacoes);
  }

  return (
    <OperacaoContext.Provider
      value={{
        getOperacoes,
        operacoes,
        handleAddOperacao,
        handleDeleteOperacao,
        handleUpdateOperacao,
      }}
    >
      <>{children}</>
    </OperacaoContext.Provider>
  );
}

function useOperacao() {
  const context = useContext(OperacaoContext);

  return context;
}

export { OperacaoProvider, useOperacao };
